module.exports = __webpack_public_path__ + "static/media/mouton_03_full.e6ece854.jpg";